import { render, staticRenderFns } from "./commissionManagement.vue?vue&type=template&id=54b7f8b4&scoped=true&"
import script from "./commissionManagement.vue?vue&type=script&lang=js&"
export * from "./commissionManagement.vue?vue&type=script&lang=js&"
import style0 from "./commissionManagement.vue?vue&type=style&index=0&id=54b7f8b4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54b7f8b4",
  null
  
)

export default component.exports